import { ca } from '@cian/analytics';

export function trackPreInfiniteSaveSearchShow() {
  ca('event', {
    action: 'show_saved_search_infinite',
    category: 'Listing',
    name: 'oldevent',
  });
}

export function trackSaveSearchFromPreInfinite() {
  ca('event', {
    action: 'Send',
    category: 'subscription',
    label: 'From_cat_save_infinite',
    name: 'oldevent',
  });
}
